import Cookies from 'js-cookie';
import firebase from '../Firebase';

// Saying "Connect" (interested) or "Not interested" to a suggested member —
// from the card itself (Message/Suggestions.js) or their full profile
// (Message/SuggestionProfile.js), in Messenger or the /meet chat. Records it
// (POST /interRecord/update — mutual interest leads to an introduction) and,
// for Connect, posts the bot's acknowledgement in their bot chat.
export const respondToSuggestion = async ({ choosingUser, consideredUser, isInterested, communityId, conversationId }) => {
  const token = await firebase.auth().currentUser.getIdToken(true);
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`, 'X-CSRF-Token': Cookies.get('mytoken') };
  const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/interRecord/update`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ choosingUser, consideredUser, verdict: isInterested, communityId }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  if (isInterested && data && conversationId) {
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/interMessaging/interestAcknowledgeMessage`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ choosingUser: choosingUser.userId, interestedInUserName: consideredUser.name, communityId, conversationId }),
    }).catch(() => {});
  }
  return data;
};
